import { MoneyInput as KitMoneyInput } from '@parsina/framework';

import { useTranslation } from '../../i18n';
import { isUnknownCurrency } from '../../lib/currency';

/**
 * The kit's `MoneyInput`, with the one case the kit cannot handle: a currency
 * this build does not know (docs/clinic-currency/CONTRACTS.md).
 *
 * Every money field in the app imports THIS, never the kit's directly, and the
 * props are the kit's own. For every allowed currency — and for IRR, byte for byte
 * — it is the kit's field with the currency passed through; a blank `currency`
 * means the one in context (the clinic's, or the document's being edited).
 *
 * For an unknown code the kit would throw, and guessing would be worse: there is no
 * scale to turn what a person types into the currency's minor units. So the field
 * is DISABLED, its chip reads the code (never «تومان»), and a note under it says
 * the app has to be updated to enter amounts in that currency.
 */
export default function MoneyInput({ currency, ...props }) {
  const { t, currency: inContext } = useTranslation();
  const code = currency || inContext;

  if (!isUnknownCurrency(code)) return <KitMoneyInput {...props} currency={code} />;

  return (
    <KitMoneyInput
      {...props}
      currency={undefined}
      unitLabel={props.unitLabel ?? code}
      disabled
      error={undefined}
      helperText={t('common.money.unsupportedCurrency', { code })}
      data-currency-unsupported={code}
    />
  );
}
